import {
  GET_STATISTICS,
  GET_STATISTICS_SUCCESS,
  GET_STATISTICS_CATEGORIES_SUCCESS,
  CLEAR_STATISTICS_REDUCER,
} from '../constants/ActionTypes';

export const initialState = {
  loading: false,
  statistic: [],
  pageCount: null,
  categories: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STATISTICS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_STATISTICS_SUCCESS: {
      return {
        ...state,
        loading: false,
        statistic: action.payload.statistic,
        pageCount: action.payload.pageCount,
      };
    }

    case GET_STATISTICS_CATEGORIES_SUCCESS: {
      return {
        ...state,
        loading: false,
        categories: action.payload.categories,
      };
    }

    case CLEAR_STATISTICS_REDUCER: {
      return initialState;
    }

    default:
      return state;
  }
};
